import React from 'react';
import TreeItem from './tree_item';
import { TreeViewProvider } from './tree_view_provider';
const TreeView = (props) => {
    const { collapseIcon, data, expandIcon, additionalCollapseIcon, additionalExpandIcon, onNodeSelect, selectedId, menu, onMenuClick, } = props;
    const icons = Object.assign(Object.assign(Object.assign(Object.assign({}, (collapseIcon && { collapseIcon })), (expandIcon && { expandIcon })), (additionalCollapseIcon && { additionalCollapseIcon })), (additionalExpandIcon && { additionalExpandIcon }));
    const renderTree = (nodes) => nodes.map((node) => {
        return (React.createElement(TreeItem, { key: node.id, node: node, label: node.name, onNodeSelect: onNodeSelect, selectedId: selectedId, menu: typeof menu === 'function' ? menu(node) : menu, onMenuClick: onMenuClick }, Array.isArray(node.children) && node.children.length > 0
            ? renderTree(node.children)
            : null));
    });
    return (React.createElement(TreeViewProvider, { icons: icons, selectedId: selectedId, treeNodes: data }, renderTree(data)));
};
export default TreeView;
